import React from "react";

const ContactDemoExpectations = () => {
  const steps = [
    {
      title: "Step 1: We Learn About Your Practice",
      description:
        "We'll ask about your specialty (implants, cosmetic, orthodontic), patient volume, current case acceptance rate, and biggest consultation challenges. This helps us tailor the demo to your actual workflow.",
    },
    {
      title: "Step 2: Live AI Smile Simulation Walkthrough",
      description:
        "We'll run a live demo of SmileReveal™ using a sample patient case relevant to your specialty. You'll see exactly how the AI generates photorealistic smile simulations in seconds — including custom shade previews, animated videos, and mobile sharing.",
    },
    {
      title: "Step 3: Custom Implementation Plan",
      description:
        "Based on your practice size and goals, we'll recommend the right SmileReveal plan and walk you through setup, integration with your existing systems, and how to start using AI smile simulation in consultations within the same week.",
    },
  ];

  return (
    <section className="py-24 px-3 sm:px-4 lg:px-6 bg-[#fdfdfd]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 px-4">
          <h2 className="text-3xl md:text-5xl font-bold text-[#1a1a1a] mb-6 tracking-tight leading-tight">
            What to Expect from Your AI Smile Simulation Demo
          </h2>
          <p className="text-slate-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Your personalized SmileReveal™ demo takes about 20 minutes and
            covers everything you need to see.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-50/50 rounded-full blur-3xl -mr-16 -mt-16 transition-transform group-hover:scale-110" />
              <h3 className="text-xl font-bold text-slate-900 mb-4 relative z-10">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed relative z-10">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-sm font-semibold text-slate-500 uppercase tracking-wide">
            No pressure, no obligation. Just a clear picture of how SmileReveal™
            AI smile simulation can help your dental practice close more cases
            and grow revenue.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactDemoExpectations;
